// TODO: UI Upgrade - post-upgrade, clean up this component.
// It's not clear to me te purpose of this component. It seems to be just a wrapper for SelectEntity. The modules from
// these unused seem to have been move to SelectEntity. But why use this component at all then? Is this just checking
// if something is "in progress" and then showing a Loading message?

import React from 'react';
import { useEntityState } from '../../stores/entity/entity.hooks';
import CustomLoading from '../custom/custom-loading';
import { SelectEntity } from './select-entity';

export const JourneyEntity: React.FC = () => {
 
  const { journeyTasksLoadInProgress, entitiesLoadInProgress, dataGroupsLoadInProgress } = useEntityState();
  

 return (
  <>
   <SelectEntity/>
    {(entitiesLoadInProgress || dataGroupsLoadInProgress || journeyTasksLoadInProgress)  &&  <CustomLoading message='Loading..'/>}
    </>
  );
};
